import { useMemo } from 'react'
import { useSetAtom } from 'jotai'

import { authTokenAtom } from '../atoms/auth-token.atom'

export const useAuthTokenSetter = () => {
    const tokenSetter = useSetAtom(useMemo(() => authTokenAtom, []))

    return {
        tokenSetter,
    }
}
